/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['underscore', 'assets/js/backbone-extended', 'assets/js/modules/designFacePreview/model/productPreviewInfoModel'], function(
    _,
    backboneExtended,
    ProductPreviewInfoModel
) {
    return backboneExtended.NestedModel.extend(
        {
            relations: {
                productPreviewInfo: ProductPreviewInfoModel
            },
            defaults: {
                pgId: null,

                productSlug: null,

                shape: null,

                isVertical: false,

                guideLinesOptions: {},

                mailingServicesGuidesOptions: {}
            },

            initialize: function() {
                var _this = this;
                var productInfo = this.get('productPreviewInfo');

                this.set('options', this.get('options') || {});

                //merge options with default options
                _.each(productInfo.get('defaultOptions'), function(optionValueName, optionName) {
                    if (!_this.hasOption(optionName)) {
                        _this.get('options')[optionName] = optionValueName;
                    }
                });

                this.set('shape', productInfo.get('shape'));
            },

            /**
             * @param {string} optionName
             * @returns {boolean}
             */
            hasOption: function(optionName) {
                return this.get('options')[optionName] !== undefined;
            },

            /**
             * @param {string} optionName
             * @param {string} optionValueName
             * @returns {boolean}
             */
            hasOptionValue: function(optionName, optionValueName) {
                return this.hasOption(optionName) && this.get('options')[optionName] == optionValueName;
            },

            /**
             * @param {string} optionName
             * @param {string} optionValueName
             */
            setOption: function(optionName, optionValueName) {
                this.get('options')[optionName] = optionValueName;
            }
        },
        {
            SHAPES: {
                CIRCLE: 'circle'
            },
            OPTIONS: {
                HOLE_DRILLED: 'hole-drilled',
                ROUNDED_CORNERS: 'rounded'
            },
            FACE_NAMES: {
                FRONT: 'front',
                BACK: 'back'
            },
            PAGE: {
                FRONT: 1,
                BACK: 2
            },
            BOOKBLOCK: {
                CLASS: 'bb-bookblock',
                ITEM_CLASS: 'bb-item'
            }
        }
    );
});
